import { Box, ButtonBase, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const STEPS = ["Constat", "Ouverture", "Curatif", "Analyse", "Action"];

const StepBar = ({ activeStep, navigationEnabled, onStepChange }) => (
  <Paper
    aria-label="Progression de la saisie de la non-conformité"
    elevation={0}
    role="navigation"
    sx={{
      border: "1px solid #cbd8e6",
      borderRadius: "12px",
      boxShadow: "0 4px 14px rgba(23, 61, 97, 0.05)",
      overflowX: "auto",
      px: { xs: 2, sm: 4 },
      py: 1.5,
    }}
  >
    <Box
      component="ol"
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${STEPS.length}, minmax(90px, 1fr))`,
        listStyle: "none",
        m: 0,
        minWidth: 560,
        p: 0,
      }}
    >
      {STEPS.map((label, index) => {
        const isActive = index === activeStep;
        const isComplete = index < activeStep;
        const isDisabled = !navigationEnabled || isActive;
        const circleColor = isComplete ? "#159447" : isActive ? "#00a6b6" : "#fff";
        const borderColor = isComplete
          ? "#159447"
          : isActive
          ? "#00a6b6"
          : "#c7d3e4";

        return (
          <Box
            component="li"
            key={label}
            sx={{ position: "relative", textAlign: "center" }}
          >
            {index > 0 && (
              <Box
                aria-hidden="true"
                sx={{
                  backgroundColor: isActive
                    ? "#159447"
                    : isComplete
                    ? "#159447"
                    : "#ccd7e7",
                  height: 2,
                  position: "absolute",
                  right: "50%",
                  top: 17,
                  width: "100%",
                }}
              />
            )}
            <ButtonBase
              aria-current={isActive ? "step" : undefined}
              aria-disabled={isDisabled}
              aria-label={`Aller à l'étape ${index + 1} : ${label}`}
              disabled={isDisabled}
              onClick={() => onStepChange(index)}
              sx={{
                alignItems: "center",
                borderRadius: 1,
                cursor: isDisabled ? "default" : "pointer",
                display: "inline-flex",
                flexDirection: "column",
                justifyContent: "center",
                position: "relative",
                px: 0.75,
                zIndex: 1,
                "&.Mui-focusVisible": {
                  outline: "3px solid #d4ad3d",
                  outlineOffset: 3,
                },
              }}
            >
              <Box
                sx={{
                  alignItems: "center",
                  backgroundColor: circleColor,
                  border: `2px solid ${borderColor}`,
                  borderRadius: "50%",
                  boxShadow: isActive ? "0 0 0 4px #d9f3f6" : "none",
                  color: isActive || isComplete ? "#fff" : "#60758a",
                  display: "inline-flex",
                  fontSize: 13,
                  fontWeight: 800,
                  height: 34,
                  justifyContent: "center",
                  width: 34,
                }}
              >
                {index + 1}
              </Box>
              <Typography
                color={isComplete ? "#159447" : isActive ? "#0096a7" : "#536b91"}
                fontSize={10}
                fontWeight={isActive ? 800 : 600}
                sx={{ mt: 0.6 }}
              >
                {label}
              </Typography>
            </ButtonBase>
          </Box>
        );
      })}
    </Box>
  </Paper>
);

StepBar.defaultProps = {
  activeStep: 0,
  navigationEnabled: false,
  onStepChange: () => {},
};

StepBar.propTypes = {
  activeStep: PropTypes.oneOf([0, 1, 2, 3, 4]),
  navigationEnabled: PropTypes.bool,
  onStepChange: PropTypes.func,
};

export default StepBar;
